<template>
  <div class="average-score">
    <score
      :score="averageScore"
      :short="true"
      :size="size"
      color="#4662f7"
    />
  </div>
</template>

<script>
import Score from '@/components/Card/Score.vue';

export default {
  name: 'AverageScore',
  components: {
    Score,
  },
  props: {
    averageScore: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
};
</script>

<style scoped lang="scss">
.average-score {
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
}
</style>
